module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/ef3bd5f70b7a1aa44a632cf62e0338f6.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fef3bd5f70b7a1aa44a632cf62e0338f6.png
// module id = VtnN
// module chunks = 93